import { IconSupplier } from '~/design-system';
import { getApi } from '~/platform/data/apiSingleton';
import type { ModuleDefinition } from '~/platform/registry/types';

/* ------------------------------------------------------------------ *
 * Suppliers — the answer to "what does each stand need to bring".
 * The old admin held this in per-supplier pages assembled by hand;
 * here every sheet is derived from the same day-demand rows the
 * grouping board writes.
 * ------------------------------------------------------------------ */

export const suppliersModule: ModuleDefinition = {
  id: 'suppliers',
  i18nNamespace: 'suppliers',
  requires: { subject: 'contact', action: 'read' },

  nav: {
    labelKey: 'suppliers:nav',
    icon: IconSupplier,
    to: 'suppliers',
    group: 'move',
    order: 15,
  },

  routes: [{ path: 'suppliers', component: () => import('./SuppliersPage') }],

  commands: [
    {
      id: 'suppliers.open',
      labelKey: 'suppliers:title',
      groupKey: 'suppliers:title',
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/suppliers`),
    },
  ],

  search: async (query, { businessId, businessSlug }) => {
    const parties = await getApi().listParties(businessId, {
      search: query,
      role: 'supplier',
      limit: 6,
    });
    return parties.slice(0, 6).map((party) => ({
      id: party.id,
      moduleId: 'suppliers' as const,
      code: party.code,
      title: party.name,
      subtitle: party.supplier?.standCode ?? undefined,
      handlingClass: 'neutral',
      to: `/b/${businessSlug}/suppliers?supplier=${party.id}`,
    }));
  },
};
